const validation = {
  emailIsRequiredField: 'Электронная почта – обязательное поле',
  usernameIsRequiredField: 'Имя пользователя – обязательное поле',
  passwordIsRequiredField: 'Пароль – обязательное поле',
  tocIsRequiredField: 'Содержание – обязательное поле',
  nicknameIsRequiredField: 'Никнейм – обязательное поле',
  fillNameIsRequiredField: 'Полное имя – обязательное поле',
  businessTypeIsRequiredField: 'Тип бизнеса – обязательное поле',
  countryIsRequiredField: 'Страна – обязательное поле',
  phoneIsRequiredField: 'Телефон – обязательное поле',
  phoneMustContainOnlyNumbers: 'Телефон должен содержать только цифры',
  thereShouldBePhoneOrMessenger: 'Нужно указать номер телефона или мессенджер',
  nicknameIsNotValid: 'Псевдоним недействителен',
  fullNameIsNotValid: 'Полное имя недействительно',
  emailMustBeAtLeast: 'Электронный адрес должен содержать не менее 4 символов',
  emailIsNotValid: 'Электронный адрес недействителен',
  passwordMustBeAtLeast: 'Пароль должен содержать не менее 8 символов',
  userNameMustBeAtLeast: 'Имя пользователя должно содержать не менее 3 символов',
  passwordsMustMatch: 'Пароли должны совпадать',
  imageTooLarge: 'Изображение слишком велико',
};
export default validation;
